<template>
    <div class="page noselect">
        <!--        <div class="absBack">-->
        <!--            <div onclick="window.history.back()">-->
        <!--                <v-icon  medium dark>mdi-arrow-left</v-icon>-->
        <!--            </div>-->
        <!--        </div>-->

        <!--        <h1 class="myTitle">AGB</h1>-->

        <v-container grid-list-md>
            <div class="text-center mt-7">
                <h2>Hinweise zu Allergenen</h2>
                <div class="spacer-25"></div>
                <div class="text-left">
                    <p>
                        Liebe Gäste,
                    </p>
                    <p>
                        Wir bereiten alle Speisen für dich frisch zu und verzichten, womöglich, auf Konservierungsstoffe
                        und Geschmacksverstärker. Wir haben versucht alle möglichen enthaltenen Allergene und Zusatzstoffe
                        zu kennzeichnen. Sollten noch Fragen offen sein, versuchen wir gerne weiterzuhelfen.
                    </p>
<!--                    <p>-->
<!--                        In Unseren Speisen Können Spuren Von Folgenden Produkten vorhanden sein:-->
<!--                        GL: Getreide (Gluten), SJ: Sojabohnen, MI: Milch, KR: Krebstiere, EI: Eier, FI: Fische, WE:-->
<!--                        Schalentiere/Weichtiere,-->
<!--                        ER: Mandeln/Pistazien/Haselnüsse/Walnüsse/Erdnüsse, SL: Sellerie, SF: Senf, SE: Sesamsamen.-->
<!--                    </p>-->
                </div>
                <div class="spacer-15"></div>
                <AllergenLegende :compact="false"></AllergenLegende>


            </div>
        </v-container>
    </div>
</template>

<script>
    // import * as iframe from "../iframe/handleFrameUpdates"
    // import {logPageView} from "../firebase/firebaseUtil";

    import AllergenLegende from "../components/AllergenLegende";

    export default {
        components: {AllergenLegende}
    }
</script>

<style scoped lang="scss">

</style>